import { ActionTree } from 'vuex/types/index'

import { SohoModel } from '~/constants/SohoModel'
import { RootState } from '~/store/store.types'
import { RequestParameters } from '~/utils/SohoApi/SohoApi'

import {
  NotificationState,
  ShNotification,
  ShNotificationResource,
  ShNotificationGroup
} from './notification.types';

const actions: ActionTree<NotificationState, RootState> = {
  async fetchNotifications ({ commit }, { params = {},  isPaginating = false } = {}) {
    try {
      const { data, meta } = await this.$sohoApi.get<ShNotificationResource>(SohoModel.Notification, params)
      commit('SET_NOTIFICATIONS', { data, params, meta, isPaginating })
    } catch (error) {
      // TODO handle error notifcation
    }
  },

  async dismissNotification ({ commit }, { id }: Partial<ShNotification>) {
    try {
      await this.$sohoApi.patch<ShNotification>(
        SohoModel.Notification,
        { id, type: SohoModel.Notification, dismissed: true }
      )

      commit('DELETE_NOTIFICATION', id)
    } catch (error) {
      // TODO handle error notifcation
    }
  },

  async dismissNotificationGroup ({ commit }, group: ShNotificationGroup) {
    try {
      await this.$sohoApi.patch<ShNotificationGroup>(SohoModel.NotificationGroup, { ...group, dismissed: true, seen: true })

      commit('DELETE_NOTIFICATIONS_BY_GROUP', group.id)
    } catch (error) {
      // TODO handle error notifcation
    }
  },

  async markNotificationsAsSeen ({ commit }, group: ShNotificationGroup) {
    try {
      await this.$sohoApi.patch<ShNotificationGroup>(SohoModel.NotificationGroup, { ...group, seen: true })

      commit('SEEN_NOTIFICATIONS_BY_GROUP', group.id)
    } catch (error) {
      // TODO handle error notifcation
    }
  }
}

export default actions
